import { Text, TouchableOpacity, View } from "react-native";
import { TileProps } from "./TilesList.type";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { useCallback } from "react";
import styles from "./TilesList.styles";

export default function Tile({ tile, onPress } : TileProps){
    const handlePress = useCallback(() => {
        onPress?.(tile)
    }, [onPress, tile])

    return (
        <TouchableOpacity
            key={tile.id}
            style={styles.tileCard}
            onPress={() => handlePress()}
            activeOpacity={0.8}
        >
            <View style={[styles.tileIconWrap, { backgroundColor: tile.background }]}>
                <MaterialCommunityIcons name={tile.icon} size={22} color={tile.color} />
            </View>

            <View style={styles.tileText}>
                <Text style={styles.tileTitle}>{tile.title}</Text>
                <Text style={styles.tileSubtitle}>{tile.subtitle}</Text>
            </View>

            <MaterialCommunityIcons name="chevron-right" size={22} color="#C7CBD1" />
        </TouchableOpacity>
    );
}
